/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSecretsGet } from '../fn/secrets/api-secrets-get';
import { ApiSecretsGet$Params } from '../fn/secrets/api-secrets-get';
import { apiSecretsIdDelete } from '../fn/secrets/api-secrets-id-delete';
import { ApiSecretsIdDelete$Params } from '../fn/secrets/api-secrets-id-delete';
import { apiSecretsIdGet } from '../fn/secrets/api-secrets-id-get';
import { ApiSecretsIdGet$Params } from '../fn/secrets/api-secrets-id-get';
import { apiSecretsIdPut } from '../fn/secrets/api-secrets-id-put';
import { ApiSecretsIdPut$Params } from '../fn/secrets/api-secrets-id-put';
import { apiSecretsPost } from '../fn/secrets/api-secrets-post';
import { ApiSecretsPost$Params } from '../fn/secrets/api-secrets-post';
import { SecretListItemResult } from '../models/secret-list-item-result';
import { SecretResult } from '../models/secret-result';


/**
 * Secret management
 */
@Injectable({ providedIn: 'root' })
export class SecretsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSecretsGet()` */
  static readonly ApiSecretsGetPath = '/api/Secrets';

  /**
   * Get all secrets accessible by the current user (without values).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSecretsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsGet$Response(params?: ApiSecretsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecretListItemResult>>> {
    const obs = apiSecretsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all secrets accessible by the current user (without values).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSecretsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsGet(params?: ApiSecretsGet$Params, context?: HttpContext): Observable<Array<SecretListItemResult>> {
    const resp = this.apiSecretsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SecretListItemResult>>): Array<SecretListItemResult> => r.body)
    );
  }

  /** Path part for operation `apiSecretsPost()` */
  static readonly ApiSecretsPostPath = '/api/Secrets';

  /**
   * Create a new secret.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSecretsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSecretsPost$Response(params?: ApiSecretsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResult>> {
    const obs = apiSecretsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new secret.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSecretsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSecretsPost(params?: ApiSecretsPost$Params, context?: HttpContext): Observable<SecretResult> {
    const resp = this.apiSecretsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecretResult>): SecretResult => r.body)
    );
  }

  /** Path part for operation `apiSecretsIdGet()` */
  static readonly ApiSecretsIdGetPath = '/api/Secrets/{id}';

  /**
   * Get a secret by ID (with decrypted value).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSecretsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsIdGet$Response(params: ApiSecretsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResult>> {
    const obs = apiSecretsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a secret by ID (with decrypted value).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSecretsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsIdGet(params: ApiSecretsIdGet$Params, context?: HttpContext): Observable<SecretResult> {
    const resp = this.apiSecretsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecretResult>): SecretResult => r.body)
    );
  }

  /** Path part for operation `apiSecretsIdPut()` */
  static readonly ApiSecretsIdPutPath = '/api/Secrets/{id}';

  /**
   * Update a secret (name and/or value).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSecretsIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSecretsIdPut$Response(params: ApiSecretsIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResult>> {
    const obs = apiSecretsIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a secret (name and/or value).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSecretsIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSecretsIdPut(params: ApiSecretsIdPut$Params, context?: HttpContext): Observable<SecretResult> {
    const resp = this.apiSecretsIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecretResult>): SecretResult => r.body)
    );
  }

  /** Path part for operation `apiSecretsIdDelete()` */
  static readonly ApiSecretsIdDeletePath = '/api/Secrets/{id}';

  /**
   * Delete a secret (soft delete).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSecretsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsIdDelete$Response(params: ApiSecretsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiSecretsIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a secret (soft delete).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSecretsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSecretsIdDelete(params: ApiSecretsIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiSecretsIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
